var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84779 1.10827L10.1452 2.16421C10.2705 2.28627 10.3407 2.45405 10.3397 2.62895C10.3387 2.80385 10.2665 2.97081 10.1399 3.09142L9.15397 4.29211L5.7987 8.38581C5.74061 8.45421 5.6624 8.50253 5.57524 8.52389L3.83557 8.92412C3.60473 8.93367 3.40567 8.76341 3.3793 8.53389L3.46068 6.81757C3.46671 6.72994 3.50141 6.64673 3.55941 6.58076L6.76993 2.66851L7.90058 1.28904C8.12026 0.990028 8.53344 0.911174 8.84779 1.10827Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    d: "M1 10.6C0.779086 10.6 0.6 10.779 0.6 11C0.6 11.2209 0.779086 11.4 1 11.4V10.6ZM10.1386 11.4C10.3595 11.4 10.5386 11.2209 10.5386 11C10.5386 10.779 10.3595 10.6 10.1386 10.6V11.4ZM7.14086 2.51874C7.05817 2.31388 6.82507 2.21485 6.62021 2.29753C6.41536 2.38022 6.31632 2.61332 6.39901 2.81817L7.14086 2.51874ZM9.24212 4.68423C9.4576 4.63555 9.59282 4.4214 9.54414 4.20592C9.49546 3.99044 9.28132 3.85521 9.06583 3.90389L9.24212 4.68423ZM1 11.4H10.1386V10.6H1V11.4ZM6.39901 2.81817C6.54983 3.19183 6.86068 3.72587 7.32118 4.13537C7.7887 4.55112 8.44514 4.86427 9.24212 4.68423L9.06583 3.90389C8.59608 4.01002 8.19391 3.84089 7.85279 3.53756C7.50466 3.22797 7.25686 2.80613 7.14086 2.51874L6.39901 2.81817Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.98e569e7ac073ece5283f0b318616f3d.svg";
export { ForwardRef as ReactComponent };